import { GTM_EVENT_CATEGORY } from '@/lib/tracking/types/GTM_EVENT_CATEGORY'

export const SECTION_REQUIRED_CATEGORIES = new Set([
  GTM_EVENT_CATEGORY.DONATION,
  GTM_EVENT_CATEGORY.VENDOR_CLICK,
])

export const GTM_CONFIG = {
  [GTM_EVENT_CATEGORY.DONATION]: {
    event: 'donaButton',
    eventName: 'dona_ora_ads',
  },

  [GTM_EVENT_CATEGORY.NEWSLETTER]: {
    event: 'nrNewsletter',
    eventName: 'newslettersignup_ads',
  },

  [GTM_EVENT_CATEGORY.QUERY_LOCATION]: {
    event: 'ricercaPiazza',
    eventName: 'ricerca_piazza_arance',
  },

  // TODO support multiple vendors
  [GTM_EVENT_CATEGORY.VENDOR_CLICK]: {
    event: 'amazonButton',
    eventName: 'goto_amazon',
  },

  [GTM_EVENT_CATEGORY.DISTRIBUTION]: {
    event: 'puntiDistribuzione',
    eventName: 'punto_distribuzione',
    buttonName: 'punti di distribuzione',
  },

  [GTM_EVENT_CATEGORY.LOCATION_ACTIONS]: {
    event: 'ricercaInsights',
    eventName: 'ricerca_piazza_insights',
  },

  [GTM_EVENT_CATEGORY.EVENT_CLICKTHROUGH]: {
    event: `initiativeBtn`,
    eventName: `evento_ads`,
  },

  [GTM_EVENT_CATEGORY.PARTNER_CLICKTHROUGH]: {
    event: 'extBtn',
    eventName: 'partner_clicked',
  },

  [GTM_EVENT_CATEGORY.RECIPE_CLICK]: {
    event: 'click_ricette',
    eventName: 'click_ricette',
  },

  [GTM_EVENT_CATEGORY.SUPPORT_US]: {
    event: 'formSostieni',
    eventName: 'sostienici_tipologie',
  },

  [GTM_EVENT_CATEGORY.HEADER_NAVIGATION]: {
    event: 'click_header',
    eventName: 'click_header',
  },

  [GTM_EVENT_CATEGORY.FOOTER_NAVIGATION]: {
    event: 'click_footer',
    eventName: 'click_footer',
  },

  [GTM_EVENT_CATEGORY.GENERIC_CTA_CLICK]: {
    event: 'btn_click',
    eventName: 'button_click',
  },

  [GTM_EVENT_CATEGORY.VIDEO_CLICK]: {
    event: 'guardaVideo',
    eventName: 'video_arance',
  },
} as const
